import type { FaireProductEntity } from "../../entity_types/product";

export const p_8eucw735c6: FaireProductEntity = {
  token: "p_8eucw735c6",
  type: "product",
  name: "Best of Lips & Eyes Boxset",
  brandToken: "b_bhjlp1y7g0",
  brandName: "Vitamasques US",
  imageUrl:
    "https://cdn.faire.com/fastly/79b87e9edad70c3d78cdd5471bcc6794b7c63338495b9e19aba083c11086180c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f96f16897723d2a5ec7780076bdfb019d101c21e5b741b51929625fe81a32e45.png",
    "https://cdn.faire.com/fastly/a13c0398c1ed7ab42de84d3d478912d47975c2e8551e150aef9dc03d1003ec50.png",
    "https://cdn.faire.com/fastly/9e6ce0771b943734a47bfeb4ffb4f3041a64f5dde9950d4ed4064a8c1d5a2a67.png",
  ],
  priceDollars: 5.99,
  description:
    "A limited-edition lip and eye mask box set that includes 2 of our best-selling lip masks and 2 pairs of luxurious diamond eye pads. Taking care of the most delicate parts of your face while you relax.\n\nDiamond Eye Pads care for the delicate under-eye area with de-puffing and brightening-focused ingredients to give a rejuvenated glow to tired eyes.\n\nLip Masks care for damaged and dry lips with a much-needed boost of hydration and plumping effects.\n\nFree-from: Parabens, Mineral Oils, Triclosan, Phthalates, Animal Cruelty, Sodium Lauryl Sulfate and Gluten. Plus it's Vegan-Friendly.\n\n• Vegan-Friendly & Cruelty-Free\n• Dermatologically tested\n• Contains super skincare ingredients such as Multi Molecular Hyaluronic Acid, Vegan Collagen, Diamond and Caffeine extracts.\n• A perfect skincare giftset for sharing or self-caring alike.\n\n#Korean eye pads #Lip mask #Easter gift #Spring #Perfect Mother's Day gift #Father's Day #Summer #Christmas stuffer #Eye mask #Best gift set",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:46.247Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
